import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=a4622960&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=a4622960&prod&lang=scss&scoped=true"
import style1 from "./Home.vue?vue&type=style&index=1&id=a4622960&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4622960",
  null
  
)

export default component.exports